module.exports = __webpack_public_path__ + "static/media/WebsiteBanner.1aebfe00.png";